export const settingsConstants = {
    UPDATE_REQUEST: 'SETTINGS_UPDATE_REQUEST',
    UPDATE_SUCCESS: 'SETTINGS_UPDATE_SUCCESS',
    UPDATE_FAILURE: 'SETTINGS_UPDATE_FAILURE',

    UPLOAD_REQUEST: 'SETTINGS_UPLOAD_REQUEST',
    UPLOAD_SUCCESS: 'SETTINGS_UPLOAD_SUCCESS',
    UPLOAD_FAILURE: 'SETTINGS_UPLOAD_FAILURE',
    
    FETCH_REQUEST: 'SETTINGS_FETCH_REQUEST',
    FETCH_SUCCESS: 'SETTINGS_FETCH_SUCCESS',
    FETCH_FAILURE: 'SETTINGS_FETCH_FAILURE',   

    GLOBAL_UPDATE_REQUEST: 'GLOBAL_SETTINGS_UPDATE_REQUEST',
    GLOBAL_UPDATE_SUCCESS: 'GLOBAL_SETTINGS_UPDATE_SUCCESS',
    GLOBAL_UPDATE_FAILURE: 'GLOBAL_SETTINGS_UPDATE_FAILURE',
    
    GLOBAL_FETCH_REQUEST: 'GLOBAL_SETTINGS_FETCH_REQUEST',
    GLOBAL_FETCH_SUCCESS: 'GLOBAL_SETTINGS_FETCH_SUCCESS',
    GLOBAL_FETCH_FAILURE: 'GLOBAL_SETTINGS_FETCH_FAILURE',   

    ACTION_SYNC_REQUEST: 'ACTION_SYNC_REQUEST',
    ACTION_SYNC_SUCCESS: 'ACTION_SYNC_SUCCESS',
    ACTION_SYNC_FAILURE: 'ACTION_SYNC_FAILURE',

    LICENSE_UPDATE_REQUEST: 'LICENSE_UPDATE_REQUEST',
    LICENSE_UPDATE_SUCCESS: 'LICENSE_UPDATE_SUCCESS',
    LICENSE_UPDATE_FAILURE: 'LICENSE_UPDATE_FAILURE',

    WEBHOOK_FETCH_REQUEST: 'SETTINGS_WEBHOOK_FETCH_REQUEST',
    WEBHOOK_FETCH_SUCCESS: 'SETTINGS_WEBHOOK_FETCH_SUCCESS',
    WEBHOOK_FETCH_FAILURE: 'SETTINGS_WEBHOOK_FETCH_FAILURE', 

    WEBHOOK_CREATE_REQUEST: 'SETTINGS_WEBHOOK_CREATE_REQUEST',
    WEBHOOK_CREATE_SUCCESS: 'SETTINGS_WEBHOOK_CREATE_SUCCESS',
    WEBHOOK_CREATE_FAILURE: 'SETTINGS_WEBHOOK_CREATE_FAILURE', 

    WEBHOOK_UPDATE_REQUEST: 'SETTINGS_WEBHOOK_UPDATE_REQUEST',
    WEBHOOK_UPDATE_SUCCESS: 'SETTINGS_WEBHOOK_UPDATE_SUCCESS',
    WEBHOOK_UPDATE_FAILURE: 'SETTINGS_WEBHOOK_UPDATE_FAILURE', 

    WEBHOOK_DELETE_REQUEST: 'SETTINGS_WEBHOOK_DELETE_REQUEST',
    WEBHOOK_DELETE_SUCCESS: 'SETTINGS_WEBHOOK_DELETE_SUCCESS',
    WEBHOOK_DELETE_FAILURE: 'SETTINGS_WEBHOOK_DELETE_FAILURE', 

    WEBHOOK_GET_REQUEST: 'SETTINGS_WEBHOOK_GET_REQUEST',
    WEBHOOK_GET_SUCCESS: 'SETTINGS_WEBHOOK_GET_SUCCESS',
    WEBHOOK_GET_FAILURE: 'SETTINGS_WEBHOOK_GET_FAILURE', 
};
